import { Button } from "@stellar/design-system";

type CoSignerIntroProps = {
  onStart: () => void;
  onCancel: () => void;
};

export const CoSignerIntro = ({ onStart, onCancel }: CoSignerIntroProps) => (
  <div className="MultisigSetup__card MultisigSetup__card--intro">
    <h2 className="MultisigSetup__title">Set up co-signers for disbursements</h2>
    <p className="MultisigSetup__p">
      Today, one person can send a disbursement on their own. With co-signers, every disbursement
      must be signed by two people in VIA Wallet before funds go out.
    </p>
    <p className="MultisigSetup__p">To set this up, you'll need:</p>
    <ul className="MultisigSetup__list" style={{ listStyleType: "disc", paddingLeft: "1.25rem" }}>
      <li>
        <strong>A second Owner.</strong> Choose one person to co-sign enrollment with you.
      </li>
      <li>
        <strong>VIA Wallet, for both of you.</strong> You'll each create a signing key on your own
        device.
      </li>
    </ul>
    <p className="MultisigSetup__p">
      <strong>Co-signing starts once your second Owner finishes their setup.</strong>
      <br />
      After it's on, any Owner can add Financial Controllers as co-signers too, and adjust this
      later.
    </p>
    <div className="MultisigSetup__actions">
      <Button variant="primary" size="md" onClick={onStart}>
        Set up co-signing
      </Button>
      <Button variant="tertiary" size="md" onClick={onCancel}>
        Cancel
      </Button>
    </div>
  </div>
);
